import $ from "jquery";
import config from "../config/localization.json";

/**
 * LocalizationInfo enthält eine Domain-Kofiguration und Sprache im Iso-Code.
 */
class LocalizationInfo {

  /**
   * @param domain Domain-Konguration
   * @param language Sprache als Iso-Code
   */
  constructor (domain, language) {
    this.domain = domain;
    this.language = language;
  }
}

/**
 * Lokalisiert die HTML anhand der übergebenen Sprache.
 * @param lang  Sprache als Iso-Code (z.B. "de")
 */
const localizeHTMLTemplateText = (lang) => {
  // Lokalisierte Werte über den Schlüssel im Dom suchen und ersetzen
  Object.keys(config.localization[lang]).map((key) => {
    $("#tmpl-lang-" + key).text(config.localization[lang][key]);
  });
};

/**
 * Liefert die Domain-Konfiguration anhander der aufgerufenen Domain und liefert die Sprache zur Domain.
 * Bei der Sprache werden die Sprachpräferenzen des Browsers beachtet.
 *
 * @returns {LocalizationInfo}
 *          Enthält die Domain-Definitionen aus Konfiguration und Sprache als einfacher ISO-Code
 */
const getLocalizationInfo = () => {
  const domain = getCurrentPageDomain();
  const language = getPreferredLanguage(domain);
  return new LocalizationInfo(domain, language);
};

/**
 * Liefert die passende Domain-Konfiguration zur angezeigten Seite anhand das Hostnames oder den Fallback.
 *
 * @returns {Object}
 *          Domain-Konfiguration
 */
const getCurrentPageDomain = () => {
  const domainKey = Object.keys(config.domains).find((_domainKey) => { return getHostname().includes(_domainKey);});
  const domain = config.domains[domainKey];
  return domain ? domain : config.domains[config.defaults.domainKey];
};

/**
 * Liefert den Hostname der aktuell aufgerufenen Webseite.
 *
 * @returns {string}
 *          Hostname
 */
const getHostname = () => {
  return window.location.hostname;
};

/**
 * Liefert den Iso-Code der am besten passende Sprache der übergebenen Domain-Konfigurationen oder den Fallback.
 * Dabei wird die Sprach-Präferenz beachtet.
 *
 * @param domain
 *        Domain-Konfiguration
 * @returns {string}
 *          Iso-Code der am besten passende Sprache
 */
const getPreferredLanguage = (domain) => {
  const language = navigator.languages.find((lang) => domain.languages.includes(lang));
  return language ? language : domain.defaultLanguage;
};

/**
 * Ausführung im Browser...
 */
$(() => {

  // Domain und Sprache feststellen
  const localizationInfo = getLocalizationInfo();

  // Texte im HTML anpassen
  localizeHTMLTemplateText(localizationInfo.language);

});
